<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="គម្រោងទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតគម្រោងថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកគម្រោងដោយ​ឈ្មោះ ឬកំណត់ចំណាំ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>

				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>

			<md-table v-if="projectList.length > 1">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>ចំនួនរំលោះ</md-table-head>
					<md-table-head>ចំនួនឡូតិ៍នៅសល់</md-table-head>
					<md-table-head>ចំនួនឡូតិ៍សរុប</md-table-head>
					<md-table-head>ចំណាំ</md-table-head>
					<md-table-head>កាលបរិច្ឆេទបង្កើត</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(project, index) in projectList" v-if="project.id != 1">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{ project.hash }}</b></md-table-cell>
					<md-table-cell><b>{{project.name}}</b></md-table-cell>
					<md-table-cell><b v-if="project.total_loan != null">{{project.total_loan}} រំលោះ</b><b v-else>មិនមានរំលោះ</b></md-table-cell>
					<md-table-cell>
						<b v-if="project.total_loan != null">{{project.total_stock - project.total_loan}} ឡូតិ៍</b>
						<b v-else>{{project.total_stock}}</b>
					</md-table-cell>
					<md-table-cell><b>{{project.total_stock}} ឡូតិ៍</b></md-table-cell>
					<md-table-cell>{{project.note}}</md-table-cell>
					<md-table-cell>{{ config.datelify(project.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'projects/edit/'+ project.hash">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រែព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(project.hash)"  v-if="$store.state.authentication.account_type == 'sa'">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុប</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<p v-else>មិនមានគម្រោង</p>
		</div>


		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានគម្រោង</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>ឈ្មោះគម្រោង *</label>
								<md-input type="text" v-model="project.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>ចំនួនឡូតិ៍សរុប *</label>
								<md-input type="number" v-model="project.total_stock"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់ចំណាំ</label>
								<md-input type="text" v-model="project.note">
								</md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះគម្រោង</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(project.name).length > 0">{{project.name}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell style="width: 50%;">ចំនួនឡូតិ៍សរុប</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(project.total_stock).length > 0">{{project.total_stock}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់ចំណាំ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(project.note).length > 0">{{project.note}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postProject()">បង្កើត</md-button>
				</div>
			</div>

		</div>
		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបគម្រោងនេះមែនទេ ?"
			md-content="គម្រោងនេះនឹងត្រូវបានលុប។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>



</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			window.scrollTo(0,0);
			this.searchHandler();

		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: ""
				},
				project: {
					valid: false,
					name: "",
					total_stock: "",
					note: "",
				},
				loadMore: true,
				projectList: []

			}
		},
		methods: {
			postProject() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/project/post", {
					project: this.project
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "គម្រោងត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.searchHandler();
					}
					// this.loadMoreCompanyButton = true
					// this.memberList = data.body.data;
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/project/search", {
					text: this.search.text
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.projectList = more ? this.projectList.concat(data.body.data) : data.body.data;
					if (data.body.data.length == 100) this.loadMore = true
					else this.loadMore = false
				})
			},
			checkValidation() {
				if (String(this.project.name).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មានបន្ថែម",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.project = {
					valid: false,
					name: "",
					note: ""
				}
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/project/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "គម្រោងត្រូវបានលុយដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}
</style>



// WEBPACK FOOTER //
// src/pages/Projects/View.vue